import { environment } from 'src/environments/environment';

export function fullImagePath(partialPath: string) {
  if (!partialPath) return 'https://placehold.co/1066x600?text=MISSING+IMAGE';
  if (partialPath.startsWith('http')) return partialPath; // it is already the full path
  return environment.storageBase + '/' + partialPath;
}
